/**
 * File blog-custom-editor.js.
 * Handles custom editor scripts for blog posts.
 */
const callout = '.content-callout';
const calloutAnimate = 'content-callout--animate';
var list = document.querySelectorAll(callout);

function isInViewPort(element) {
  var bounding = element.getBoundingClientRect();
  if (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  ) {
    return true;
  } else {
    return false;
  }
}

// on scroll, check if each callout is in viewport
if (list.length > 0) {
  window.addEventListener('scroll', function (event) {
    for (var i = 0; i < list.length; ++i) {
      // if callout is in viewport, animate it
      if (isInViewPort(list[i])) {
        list[i].classList.add(calloutAnimate);
      }
    }
  }, false);
}